// eslint-disable-next-line import/no-amd
define([
    'jquery',
    'underscore',
    'backbone',
    '../../../utils/FormMessage',
    '../../../utils/Globals'
], ($, _, Backbone, FormMessage, Globals) => {
    // console.log(Globals);
    const MabinsoModel = Backbone.Model.extend({
        modelName: 'model',
        urlRoot: '/',
        form: null,
        defaults: {
        },
        initialize() {
        },
        getBaseWS() {
            return Globals.baseUrl.replace('http:', 'ws:').replace('https:', 'wss:');
        },
        setForm(form) {
            const items = this.serializeObject(form);
            // console.log(items);
            this.set(items, { silent: true });
            this.form = form;
        },
        validate() {
            if (this.form != null) {
                if (!this.form.validationEngine('validate')) {
                    this.form.validationEngine('detach');
                    this.form.validationEngine('attach', { scroll: false });
                    return 'form.error6';
                }
            }
        },
        save(options) {
            if (_.isFunction(options)) {
                options = {
                    success: options
                };
            }
            const mythis = this;
            if (this.form != null) {
                const oldSuccess = options.success;
                options.success = (model, response) => {
                    const formMessage = new FormMessage(response, mythis.modelName);
                    if (_.isFunction(oldSuccess)) oldSuccess(formMessage, model);
                };
                options.error = (err, err2) => {
                    console.log(err2);
                };
                return Backbone.Model.prototype.save.call(this, {}, options);
            }
            return Backbone.Model.prototype.save.call(this, {}, options);
        },
        /*
        get: function(key){
            var model = this;
            var value = Backbone.Model.prototype.get.call(this,key);
            if (_.isUndefined(value)){
                var myfunc = "get"+key.charAt(0).toUpperCase()+key.slice(1,key.length);
                if (!_.isUndefined(model[myfunc]) && _.isFunction(model[myfunc])){
                    return model[myfunc]();
                }
            }else{
                return value;
            }
        }, */
        getDate(key) {
            const value = this.get(key);
            console.log(value);
            const date = Date.parse(value);
            return date == null ? null : date.toString(Date.CultureInfo.formatPatterns.shortDate);
        },
        getTime(key) {
            const value = this.get(key);
            const date = Date.parse(value);
            return date == null ? null : date.toString(Date.CultureInfo.formatPatterns.shortTime);
        },
        serializeObject(form) {
            if (!_.isUndefined(this.backend) && this.backend) {
                const o = {};
                const a = $(form).serializeArray();
                // var view = this;
                $.each(a, function serialize() {
                    const myvalue = this.value;
                    /* if (view.isNumeric(this.value)){
                        myvalue = parseFloat(this.value);
                    } */
                    let myname = this.name;
                    let myInnername = 'id';
                    let isArray = false;
                    const matches = myname.match(/\[(.*?)\]/);
                    let arrayNumber = null;
                    if (matches) {
                        const splited = myname.split('.');
                        const splitedName = myname.split('[');
                        if (splited.length > 1 && splitedName.length > 0) {
                            [, arrayNumber] = matches;
                            isArray = true;
                            [myname] = splitedName;
                            [, myInnername] = splited;
                        }
                    }
                    if (isArray) {
                        if (o[myname] === undefined) {
                            o[myname] = [];
                        }
                        const innerName = {};
                        if (arrayNumber !== undefined && arrayNumber != null && arrayNumber !== '') {
                            if (o[myname][arrayNumber] !== undefined) {
                                o[myname][arrayNumber][myInnername] = myvalue || '';
                            } else {
                                innerName[myInnername] = myvalue || '';
                                o[myname][arrayNumber] = innerName;
                            }
                        } else {
                            if (!o[myname].push) {
                                o[myname] = [o[myname]];
                            }

                            innerName[myInnername] = myvalue || '';
                            o[myname].push(innerName);
                        }
                    } else {
                        o[myname] = myvalue;
                    }
                });
                _.each(o, (item, idx) => {
                    if (_.isArray(item)) {
                        // console.log(_.compact(item));
                        o[idx] = _.compact(item);
                    }
                });
                return o;
            }
            return _.serializeObject(form);
        },
        isNumeric(n) {
            return !_.isNaN(parseFloat(n)) && _.isFinite(n);
        }

    });
    return MabinsoModel;
});



// WEBPACK FOOTER //
// ./src/components/app/models/MabinsoModel.js